var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4C13 3.44771 13.4477 3 14 3H16C16.5523 3 17 3.44772 17 4V13C17 13.5523 16.5523 14 16 14H14C13.4477 14 13 13.5523 13 13V4Z",
    fill: "#255986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 3.44771 0.447715 3 1 3H3C3.55228 3 4 3.44772 4 4V13C4 13.5523 3.55228 14 3 14H1C0.447715 14 0 13.5523 0 13V4Z",
    fill: "#255986"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0C4.94772 0 4.5 0.447716 4.5 1V13C4.5 13.5523 4.94772 14 5.5 14H11.5C12.0523 14 12.5 13.5523 12.5 13V1C12.5 0.447715 12.0523 0 11.5 0H5.5ZM9.40811 9H7.59189V6.90811H5.5V5.09189H7.59189V3H9.40811V5.09189H11.5V6.90811H9.40811V9Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitution);
export default __webpack_public_path__ + "static/media/institution.9e7157ef539953c8ba5dc7c08561bdd1.svg";
export { ForwardRef as ReactComponent };